var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessmentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M357.071,87.929l-85-85c-1.912-1.912-4.47-2.904-7.071-2.905V0H10C4.477,0,0,4.477,0,10v470c0,5.523,4.477,10,10,10h340 c5.523,0,10-4.477,10-10V95h-0.024C359.975,92.399,358.983,89.841,357.071,87.929z M275,34.142L325.858,85H275V34.142z M340,470 H20V20h235v75c0,5.523,4.477,10,10,10h75V470z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,235v155h-15V120h-0.012c0-1.302-0.242-2.609-0.757-3.846l-25-60C427.678,52.427,424.037,50,420,50 s-7.678,2.427-9.231,6.154l-25,60c-0.515,1.237-0.757,2.544-0.757,3.846H385v360c0,5.523,4.477,10,10,10h50 c5.523,0,10-4.477,10-10v-70h25c5.523,0,10-4.477,10-10V235H470z M420,86l10,24h-20L420,86z M435,470h-30v-60h30V470z M435,390 h-30V130h30V390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,135H75c-5.523,0-10,4.477-10,10v50c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10v-50 C135,139.477,130.523,135,125,135z M115,185H85v-30h30V185z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,245H75c-5.523,0-10,4.477-10,10v50c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10v-50 C135,249.477,130.523,245,125,245z M115,295H85v-30h30V295z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,355H75c-5.523,0-10,4.477-10,10v50c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10v-50 C135,359.477,130.523,355,125,355z M115,405H85v-30h30V405z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 140,
    width: 50,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 180,
    width: 135,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 250,
    width: 50,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 290,
    width: 135,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 360,
    width: 50,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 400,
    width: 135,
    height: 20
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessment-icon.93baf1123b52539db30fd56c1ea8d412.svg";
export { ForwardRef as ReactComponent };